import {
    Icon12Cancel,
    Icon16Cancel,
    Icon16Done,
    Icon16KeyOutline,
    Icon16PenOutline,
    Icon20ArrowUturnLeftOutline,
    Icon20CloudArrowUpOutline,
    Icon20NotificationOutline,
    Icon20PictureOnSquareOutline,
    Icon20Stars,
} from '@vkontakte/icons';
import theme from '@vkontakte/vkui-tokens/themes/cloud/cssVars/theme';
import { ReactComponent as DisableAdIcon } from 'img/icons/disableAD.svg';
import { ReactComponent as LogoMailIcon16 } from 'img/icons/logo_mail_ru_16.svg';
import { ReactComponent as LogoMailIcon20 } from 'img/icons/logo_mail_ru_20.svg';
import { ReactComponent as MarkIcon } from 'img/icons/mark2.svg';
import React from 'react';

export const templateFeatureIcons = {
    vkui16Done: <Icon16Done fill={theme.colorIconAccent.normal.value} />,
    vkui16Cancel: <Icon16Cancel fill={theme.colorIconSecondary.normal.value} />,
    vkui12Cancel: <Icon12Cancel fill={theme.colorIconSecondary.normal.value} width={14} height={14} />,
    mark12x11: <MarkIcon width={12} height={11} />,
    mark13x11: <MarkIcon width={13} height={11} />,
    logoMail16: <LogoMailIcon16 height={16} />,
    logoMail20: <LogoMailIcon20 height={20} />,
    vkui16Picture: <Icon20PictureOnSquareOutline width={16} height={16} fill={theme.colorIconPrimary.normal.value} />,
    vkui16Pen: <Icon16PenOutline fill={theme.colorIconPrimary.normal.value} />,
    vkui16Cloud: <Icon20CloudArrowUpOutline width={16} height={16} fill={theme.colorIconPrimary.normal.value} />,
    vkui20Stars: <Icon20Stars fill={theme.colorAccentCyan.normal.value} />,
    disableAd20x15: <DisableAdIcon width={20} height={15} />,
    vkui20NotificationOutline: <Icon20NotificationOutline fill={theme.colorIconPrimary.normal.value} />,
    vkui20ArrowUturnLeftOutline: <Icon20ArrowUturnLeftOutline fill={theme.colorIconPrimary.normal.value} />,
    vkui16KeyOutline: <Icon16KeyOutline />,
};
